// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3q4ID","footer":"Form_footer__6gYWp"};